import { api } from "./api"

const getInformativos = async(tutorialId: string) =>{
    try{
      const query = [
          {
            "$match": {
                "_id": tutorialId
            }
          }
      ];


      const { data } = await api.post('/database/tutorial__c/aggregate', query);

         if(!Array.isArray(data)){
            return [];
        }else{
            return data[0];
        }
    }catch(error:any){
        throw error
    }
}

export { getInformativos };